import React, { useEffect, useRef, useState } from 'react'
import { 
  Button,
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogTitle, 
  FormControlLabel, 
  Grid, 
  Paper, 
  Switch, 
  Table, 
  TableBody, 
  TableCell, 
  TableContainer,
  TableHead,
  TablePagination,
  TableRow
} from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import { ValidatorForm } from 'react-material-ui-form-validator';
import { SolicitudesLaboratorioItem } from './SolicitudesLaboratorioItem';
import { confirmSolicitudAutorizadaLaboratorio } from '../../../../actions/turnos/laboratorio';

export const SolicitudesLaboratorio = ({open, closeModalHandler, 
  addedPracticasAndAbonar, parametrizacionSeleccionada}) => {
  const dispatch = useDispatch();

  const { solicitudesAutorizadas: items } = useSelector((state) => state.laboratorio);
  const { afiliado } = useSelector((state) => state.afiliacion);
  
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [dense, setDense] = useState(true);
  const [page, setPage] = useState(0);
  const componentRef = useRef(null);

  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
    scrollToTop();
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onSubmitHandler = (e) => {
    e.preventDefault();        
    const prasticaSolicitudSeleccionada = [];

    items.forEach(item => {
        const checked = e.target.elements[`solicitud-${item.idSolicitud}`]?.checked;
       
        if(checked){
          for (const [indexPr, itemPr] of item.practicas.entries()) {                    
            prasticaSolicitudSeleccionada.push({
              ...itemPr,
              indexPr,
            });  
          }
        }
    });    

    const data = {
      idAfiliado: afiliado.id_afiliado,
      practicas: prasticaSolicitudSeleccionada,
      idCentroMedico: parametrizacionSeleccionada.idCentro,
      idEfHorario: parametrizacionSeleccionada.idEfHorario,
      idEspecialidad: parametrizacionSeleccionada.idEspecialidad,
    }

    if(prasticaSolicitudSeleccionada.length > 0)
      dispatch( confirmSolicitudAutorizadaLaboratorio(data, addedPracticasAndAbonar, closeModalHandler) );
    else
      closeModalHandler();
  }

  const scrollToTop = () => {
    if (open && componentRef.current) {      
      componentRef.current.scrollIntoView();
    }
  };

  useEffect(() => {
    setTimeout(() => {
      scrollToTop()
    }, 100)
  }, []);

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={open}
      style={{maxHeight: '100%'}}
      onClose={closeModalHandler}
    >
      <ValidatorForm onSubmit={onSubmitHandler}>
        <Grid item xs={12} ref={componentRef}>
          <DialogTitle>Solicitudes Laboratorio</DialogTitle>
          <DialogContent>
            <TableContainer component={Paper} style={{ overflowX: "auto" }}>
              <Table size={dense ? "small" : "medium"} >
                <TableHead>
                  <TableRow>
                    <TableCell align="left"></TableCell>
                    <TableCell align="left">Estado</TableCell>
                    <TableCell align="left">Fecha Prescripcion</TableCell>
                    <TableCell align="left">N° Orden</TableCell>
                    <TableCell align="left">Tipo Prestacion</TableCell>
                    <TableCell align="left">Diagnostico</TableCell>
                    <TableCell align="left">Practicas</TableCell>
                    <TableCell align="left">Paciente</TableCell>                  
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items && items.length > 0 && (
                    items
                    .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                    .map((item) => (
                      <SolicitudesLaboratorioItem
                        item={item}
                        expandirPracticas={true}
                        key={item.idSolicitud?.toString()} 
                      />
                    ))
                  )}
                </TableBody>
              </Table>
            </TableContainer>
          </DialogContent>
          {items && items.length > 0 && (
            <Grid item xs={12}>
              <TablePagination
                page={page}
                component="div"
                count={items.length}
                rowsPerPage={rowsPerPage}
                onChangePage={handleChangePage}
                rowsPerPageOptions={[5, 10, 15]}
                style={{ backgroundColor: "white" }}
                labelRowsPerPage="Registros por página"
                onChangeRowsPerPage={handleChangeRowsPerPage}
              />
              <FormControlLabel
                control={
                  <Switch
                    checked={dense}
                    onChange={(e) => setDense(e.target.checked)}
                  />
                }
                label="Tamaño compacto"
              />
            </Grid>
          )}
          <DialogActions >
            <Button
              // sx={styles.button}
              variant="contained"
              color="primary"
              autoFocus
              type="submit" 
              // onClick={onSubmitHandler}
            >
              Continuar
            </Button>
          </DialogActions>
        </Grid>
      </ValidatorForm>
    </Dialog>
  );
}